import React from 'react';

function AboutWhoWeAreSection() {
  const styles = {
    section: {
      width: '100%',
      maxWidth: 1920,
      margin: '0 auto',
      padding: '80px clamp(24px, 12.5vw, 240px)',
      boxSizing: 'border-box',
      background: '#FFFFFF',
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'space-between',
      gap: 64,
      flexWrap: 'wrap'
    },
    leftCol: {
      position: 'relative',
      flex: '0 0 420px',
      maxWidth: 420,
      minWidth: 320,
      height: 460,
      overflow: 'hidden'
    },
    mainImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    },
    badge: {
      position: 'absolute',
      top: 0,
      right: 0,
      width: 190,
      height: 190,
      objectFit: 'contain',
      boxSizing: 'border-box'
    },
    rightCol: {
      flex: '1 1 440px',
      maxWidth: 680
    },
    overline: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 14,
      letterSpacing: '0.25em',
      textTransform: 'uppercase',
      color: '#090909',
      margin: '0 0 8px 0'
    },
    overlineRule: {
      display: 'inline-block',
      width: 80,
      height: 2,
      background: '#E73123',
      marginLeft: 12,
      verticalAlign: 'middle'
    },
    headingRed: {
      fontFamily: 'Lato',
      fontWeight: 800,
      fontSize: 32,
      lineHeight: 1.2,
      color: '#E73123',
      textTransform: 'uppercase',
      margin: '8px 0 0 0'
    },
    headingBlack: {
      fontFamily: 'Lato',
      fontWeight: 800,
      fontSize: 32,
      lineHeight: 1.2,
      color: '#090909',
      textTransform: 'uppercase',
      margin: 0
    },
    body: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 16,
      lineHeight: 1.7,
      color: '#838383',
      marginTop: 16,
      marginBottom: 0
    },
    bodyStrong: {
      fontWeight: 600,
      color: '#090909'
    }
  };

  return React.createElement('section', { style: styles.section },
    React.createElement('div', { style: styles.leftCol },
      React.createElement('img', {
        src: '/whoweareabout.jpg',
        alt: 'Piling columns at construction site',
        style: styles.mainImage
      }),
      React.createElement('img', {
        src: '/15years.png',
        alt: '15+ years of experience',
        style: styles.badge
      })
    ),
    React.createElement('div', { style: styles.rightCol },
      React.createElement('p', { style: styles.overline },
        'WHO WE ARE',
        React.createElement('span', { style: styles.overlineRule })
      ),
      React.createElement('h2', { style: styles.headingRed }, 'WHERE ENGINEERING'),
      React.createElement('h2', { style: styles.headingBlack }, 'EXPERTISE MEETS'),
      React.createElement('h2', { style: styles.headingBlack }, 'INFRASTRUCTURE EXCELLENCE'),
      React.createElement('p', { style: styles.body },
        React.createElement('span', { style: styles.bodyStrong }, 'Sunrise Infrabuild Pvt Ltd'),
        ' is a leading piling and excavation company, specializing in building foundations for large structures in India. We are proud to be contributing to the country\'s modern infrastructure development, from towering skyscrapers to critical infrastructure projects.'
      ),
      React.createElement('p', { style: styles.body },
        'As we expand our footprint, we\'re taking our expertise beyond India\'s borders, innovatively establishing our presence in the global market. Our team of highly trained engineers leverages the latest machines and cutting-edge techniques to deliver large-scale projects efficiently and innovatively.'
      ),
      React.createElement('p', { style: styles.body },
        'We\'re at the forefront of India\'s infrastructure revolution, playing a key role in building the backbone for the country\'s high-speed rail network, including the Bullet Train project. With a passion for progress and a commitment to excellence, we\'re paving the way for a brighter future.'
      )
    )
  );
}

export default AboutWhoWeAreSection;
